import { IncentiveOffer, IncentiveOfferType } from 'modules/incentivesMarket/types';
import { IncentivesMarketPlanContext } from 'modules/incentivesMarket/types/IncentivesMarketBeneficiaryContext';

import { distributeSellUnitsByPlan } from 'modules/incentivesMarket/pages/IncentiveOfferDetail/utils/distributeSellUnitsByPlan';

type GetIncentiveOfferAcceptTotalPriceArgs = {
  offer: Pick<IncentiveOffer, 'type' | 'unitPrice'>;
  purchaseQuantity: number;
  sellerPlans?: IncentivesMarketPlanContext[];
  retentionPercent?: number;
};

export const getIncentiveOfferAcceptTotalPrice = ({
  offer,
  purchaseQuantity,
  sellerPlans = [],
  retentionPercent = 0,
}: GetIncentiveOfferAcceptTotalPriceArgs): number => {
  const isSellOffer = offer.type === IncentiveOfferType.SELL;

  if (!isSellOffer && sellerPlans.length > 0) {
    const { total } = distributeSellUnitsByPlan({
      plans: sellerPlans,
      totalUnits: purchaseQuantity,
      sellingPrice: offer.unitPrice,
      retentionPercent,
    });

    return total;
  }

  return purchaseQuantity * offer.unitPrice;
};
